import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './bootstrap/frontendRuntimeGuards';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Add Ant Design global styles
import 'antd/dist/reset.css';

// 抑制 React DevTools 安装提示消息
// 通过设置一个虚假的 hook 来欺骗 React 认为 DevTools 已安装
if (typeof (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
  (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__ = {
    supportsFiber: true,
    inject: function () { },
    onCommitFiberRoot: function () { },
    onCommitFiberUnmount: function () { },
  };
}

// 服务已被移除，不再需要导入
// import { socketServiceInstance } from './services/socketService';
// import { salesDataServiceInstance } from './services/salesDataService';

// 服务已被移除，不再需要初始化
// const _ = { socketServiceInstance, salesDataServiceInstance };
// console.log('Services initialized:', _);

// 点击输入框时全选内容
document.addEventListener('click', (e) => {
  const target = e.target as HTMLElement;
  if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
    target.select();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
